export default "__VITE_ASSET__Bl$PB8o1__"